import { Achievement, AchievementCategory } from '@/types/achievements';

// Golf Journey Achievements - Track player's progression through the game
const journeyAchievements: Achievement[] = [
  {
    id: 'first_round',
    icon: 'rounds',
    title: 'Première Partie',
    description: 'Jouer votre première partie avec l\'app',
    earned: true,
    earnedDate: '2025-02-10',
    level: '1',
    category: 'journey'
  },
  {
    id: 'five_rounds',
    icon: 'rounds',
    title: '5 Parties',
    description: 'Jouer 5 parties',
    earned: false,
    progress: 0,
    total: 5,
    level: '5',
    category: 'journey'
  },
  {
    id: 'ten_rounds',
    icon: 'rounds',
    title: '10 Parties',
    description: 'Jouer 10 parties',
    earned: false,
    progress: 0,
    total: 10,
    level: '10',
    category: 'journey'
  },
  {
    id: 'twenty_five_rounds',
    icon: 'rounds',
    title: '25 Parties',
    description: 'Jouer 25 parties',
    earned: false,
    progress: 0,
    total: 25,
    level: '25',
    category: 'journey'
  },
  {
    id: 'fifty_rounds',
    icon: 'rounds',
    title: '50 Parties',
    description: 'Jouer 50 parties',
    earned: false,
    progress: 0,
    total: 50,
    level: '50',
    category: 'journey'
  },
  {
    id: 'hundred_rounds',
    icon: 'rounds',
    title: '100 Parties',
    description: 'Jouer 100 parties',
    earned: false,
    progress: 0,
    total: 100,
    level: '100',
    category: 'journey'
  }
];

// Course Explorer Achievements - Discovering new courses and regions
const courseExplorerAchievements: Achievement[] = [
  {
    id: 'course_explorer_5',
    icon: 'golf-flag',
    title: 'Explorateur Débutant',
    description: 'Visiter 5 parcours différents',
    earned: true,
    earnedDate: '2025-04-15',
    progress: 5,
    total: 5,
    level: '1',
    category: 'course_explorer'
  },
  {
    id: 'course_explorer_10',
    icon: 'golf-flag',
    title: 'Explorateur Intermédiaire',
    description: 'Visiter 10 parcours différents',
    earned: false,
    progress: 5,
    total: 10,
    level: '2',
    category: 'course_explorer'
  },
  {
    id: 'regional_master',
    icon: 'golf-flag',
    title: 'Maître Régional',
    description: 'Jouer dans 3 régions différentes',
    earned: false,
    progress: 1,
    total: 3,
    level: '3',
    category: 'course_explorer'
  }
];

// Skill Mastery Achievements - Performance and skill-based achievements
const skillMasteryAchievements: Achievement[] = [
  {
    id: 'birdie_collector_10',
    icon: 'birdie',
    title: 'Collectionneur de Birdies',
    description: 'Marquer 10 birdies',
    earned: false,
    progress: 0,
    total: 10,
    level: '1',
    category: 'skill_mastery'
  },
  {
    id: 'eagle_eye',
    icon: 'birdie',
    title: 'Œil d\'Aigle',
    description: 'Marquer votre premier eagle',
    earned: false,
    category: 'skill_mastery'
  },
  {
    id: 'par_excellence',
    icon: 'golf-ball',
    title: 'Par-tee',
    description: 'Terminer une partie au par ou en dessous',
    earned: false,
    category: 'skill_mastery'
  }
];

// Golf Community Achievements - Social interactions and community engagement
const communityAchievements: Achievement[] = [
  // {
  //   id: 'social_golfer',
  //   icon: 'trophy',
  //   title: 'Golfeur Social',
  //   description: 'Ajouter 5 amis à votre réseau',
  //   earned: true,
  //   earnedDate: '2025-05-10',
  //   progress: 0,
  //   total: 5,
  //   level: '1',
  //   category: 'community'
  // },
  {
    id: 'group_leader',
    icon: 'crown',
    title: 'Chef de Groupe',
    description: 'Organiser 5 parties de golf avec des amis',
    earned: false,
    progress: 0,
    total: 5,
    level: '2',
    category: 'community'
  },
  {
    id: 'community_contributor',
    icon: 'photo',
    title: 'Contributeur',
    description: 'Soumettre 10 avis ou photos de parcours',
    earned: false,
    progress: 0,
    total: 10,
    level: '3',
    category: 'community'
  }
];

// Seasonal Challenge Achievements - Time-based and seasonal achievements
const seasonalChallengeAchievements: Achievement[] = [
  {
    id: 'winter_warrior',
    icon: 'winter',
    title: 'Hors saison',
    description: 'Jouer une partie pendant les mois d\'hiver',
    earned: false,
    category: 'seasonal_challenge'
  },
  {
    id: 'summer_series',
    icon: 'sun',
    title: 'Lundi au soleil',
    description: 'Jouer 10 parties pendant l\'été',
    earned: false,
    progress: 0,
    total: 10,
    category: 'seasonal_challenge'
  }
];

// Profile Achievements - Profile completion and golf bag configuration
const profileAchievements: Achievement[] = [
  // {
  //   id: 'profile_complete',
  //   icon: 'person',
  //   title: 'Identité Confirmée',
  //   description: 'Compléter votre profil',
  //   progress: 0,
  //   total: 1,
  //   earned: false,
  //   category: 'profile'
  // },
  {
    id: 'golf_bag_basic',
    icon: 'golf-bag',
    title: 'Pimp my bag',
    description: 'Configurer votre premier sac de golf',
    earned: false,
    category: 'profile'
  },
  {
    id: 'handicap_set',
    icon: 'hcp',
    title: 'Index',
    description: 'Renseigner votre index et le faire valider',
    earned: false,
    category: 'profile'
  }
];

// Specials Achievements - Special and unique gameplay moments
const specialsAchievements: Achievement[] = [
  {
    id: 'early_access',
    icon: 'beta',
    title: 'J\'y étais!',
    description: 'Participer à la beta de CapGolf. Merci à vous !',
    earned: true,
    progress: 1,
    total: 1,
    category: 'specials'
  },
  {
    id: 'early_bird',
    icon: 'dawn',
    title: 'Lève-Tôt',
    description: 'Commencer une partie avant 8h du matin',
    earned: false,
    category: 'specials'
  },
  {
    id: 'twilight_player',
    icon: 'moon',
    title: 'Couche-tard',
    description: 'Terminer une partie après 18h',
    earned: false,
    earnedDate: '2025-05-15',
    category: 'specials'
  },
  // {
  //   id: 'marathon_golfer',
  //   icon: 'marathon',
  //   title: 'Marathonien',
  //   description: 'Jouer 36 trous en une journée',
  //   earned: false,
  //   category: 'unique_experience'
  // }
];


// Export achievement categories
export const achievementCategories: AchievementCategory[] = [
  {
    id: 'journey',
    titleKey: 'journey_achievements',
    defaultTitle: 'Parcours',
    achievements: journeyAchievements
  },
  {
    id: 'profile',
    titleKey: 'profile_achievements',
    defaultTitle: 'Profil',
    achievements: profileAchievements
  },
  // {
  //   id: 'course_explorer',
  //   titleKey: 'course_explorer_achievements',
  //   defaultTitle: 'Explorateur',
  //   achievements: courseExplorerAchievements
  // },
  // {
  //   id: 'skill_mastery',
  //   titleKey: 'skill_mastery_achievements',
  //   defaultTitle: 'Technicien',
  //   achievements: skillMasteryAchievements
  // },
  {
    id: 'community',
    titleKey: 'community_achievements',
    defaultTitle: 'Communauté',
    achievements: communityAchievements
  },
  {
    id: 'seasonal_challenge',
    titleKey: 'seasonal_challenge_achievements',
    defaultTitle: 'Défis Saisonniers',
    achievements: seasonalChallengeAchievements
  },
  {
    id: 'specials',
    titleKey: 'specials_achievements',
    defaultTitle: 'Spéciaux',
    achievements: specialsAchievements
  }
];
